import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const quickLinks = [
  { name: "About Us", href: "https://smartitbox.in/" },
  {
    name: "How It Works",
    href: "https://www.youtube.com/watch?v=KkruPC0lX4Y&t=4s",
  },
  {
    name: "Training",
    href: "https://www.youtube.com/watch?v=KkruPC0lX4Y&t=4s",
  },
];

const Footer = () => {
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion();

  return (
    <footer id="footer" className="bg-slate-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <motion.section
          initial={{ opacity: 0, y: reduceMotion ? 0 : 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="rounded-3xl border border-amber-500/20 bg-gradient-to-r from-amber-500/20 to-orange-500/20 p-6 sm:p-10"
        >
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.14em] text-amber-200">
                Ready to scale?
              </p>
              <h2 className="mt-2 text-3xl font-black leading-tight sm:text-4xl">
                Launch Your WhatsApp Growth Engine Today
              </h2>
              <p className="mt-3 max-w-xl text-sm text-amber-100/80 sm:text-base">
                Start your next campaign with clean workflows, better visibility,
                and reliable delivery.
              </p>
            </div>

            <button
              type="button"
              onClick={() => navigate("/auth")}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3 text-sm font-semibold text-amber-700"
            >
              Get Started
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </motion.section>

        <div className="mt-12 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <img src="/logo.png" alt="Smart IT Box" className="h-14 rounded-lg bg-white p-2" />
            <p className="mt-4 text-sm leading-relaxed text-slate-300">
              Smart, scalable, and clean WhatsApp messaging workflows for
              growing teams.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.12em] text-amber-200">
              Product
            </h3>
            <div className="mt-4 space-y-2">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-sm text-slate-300 transition-colors hover:text-amber-300"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.12em] text-amber-200">
              Contact
            </h3>
            <div className="mt-4 space-y-3 text-sm text-slate-300">
              <div className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 text-amber-300" />
                <span>info@smartitbox.in</span>
              </div>
              <div className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 text-amber-300" />
                <span>+91 87168 08360</span>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 text-amber-300" />
                <span>
                  2nd Floor, A-64, Sector 63, Noida, Uttar Pradesh 201301
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.12em] text-amber-200">
              Legal
            </h3>
            <div className="mt-4 space-y-2 text-sm text-slate-300">
              <p>Privacy Policy</p>
              <p>Terms of Service</p>
              <p>Cookie Policy</p>
              <p>Security</p>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-800 pt-6 text-center text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Smart IT Box. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;